import React from "react";
//CSS
import layout from "../../../Modules/layout.module.css";
import styles from "./ChatBar.module.css";
import { toast } from "react-toastify";

// Types

type ChatBarProps = {
  value: string | undefined;
  onChange: (value: string | undefined) => void;
  onSend: (value: string | undefined) => void;
  editable?: boolean;
  placeholder: string;
  isStreaming?: boolean;
  onStop?: () => void;
};

const ChatBar = ({
  value,
  onChange,
  onSend,
  editable,
  placeholder,
  isStreaming,
  onStop,
}: ChatBarProps) => {
  const hasPrompt = !!value?.trim();

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (!isStreaming) {
        handleSend();
      }
    }
  };

  const handleSend = () => {
    if (!editable || isStreaming) return;

    if (!hasPrompt) {
      toast.warn("Please type a prompt before sending.");
      return;
    }

    onSend(value?.trim());
    onChange("");
  };

  return (
    <div className={`${layout.row}`} data-testid="analyse-chat-bar">
      <div className={styles.container}>
        <textarea
          className={styles.chatInput}
          data-testid="analyse-chat-input"
          placeholder={placeholder}
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={!editable || isStreaming}
          rows={2}
        />
        {isStreaming ? (
          <div className={`${styles.chatSubmit} ${styles.chatStop}`}>
            <button
              className={styles.chatSubmit__button}
              data-testid="analyse-chat-stop"
              onClick={onStop}
              title="Stop generating"
            >
              <span className={styles.stopIcon} aria-hidden="true" />
            </button>
          </div>
        ) : (
          <div className={`${styles.chatSubmit} ${(!editable || !hasPrompt) ? styles.chatSubmitInactive : ""}`}>
            <button
              className={styles.chatSubmit__button}
              data-testid="analyse-chat-send"
              onClick={handleSend}
              disabled={!editable}
              aria-disabled={!editable || !hasPrompt}
              title={!hasPrompt ? "Type a prompt before sending" : "Send prompt"}
            >
              <img src="/img/send-icon.svg" alt="Send" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};


export default ChatBar;
